export const questionsArrayNo = [
  {
    id: 0,
    version: "long",
    level: 0,
    title: "Automatisering av prosesser",
    question:
      "Hvilket av følgende beskriver best automatiseringsnivået i dine viktigste prosesser (f.eks. produksjon, kundeservice, HR)?",
    options: [
      "Tilpasset",
      "Fullt automatisert med minimal manuell intervensjon",
      "Mest automatisert, med noen manuelle kontroller",
      "Delvis automatisert, krever betydelig manuelt arbeid",
      "Ikke automatisert; prosessene er manuelle",
    ],
  },
  {
    id: 1,
    version: "long",
    level: 0,
    question:
      "Hvilke av følgende forretningsfunksjoner er godt automatisert i organisasjonen din?",
    options: [
      "Tilpasset",
      "Produksjon/Produksjonsindustri",
      "Kundeservice",
      "HR (f.eks. lønn, onboarding)",
      "Salg og markedsføring",
      "Finans og regnskap",
      "Forsyningskjede og lagerstyring",
      "IT-støtte og vedlikehold",
    ],
  },
  {
    id: 2,
    version: "long",
    level: 0,
    question:
      "Hvilke forretningsfunksjoner ønsker du å automatisere videre i organisasjonen din?",
    options: [
      "Tilpasset",
      "Produksjon/Produksjonsindustri",
      "Kundeservice",
      "HR (f.eks. lønn, onboarding)",
      "Salg og markedsføring",
      "Finans og regnskap",
      "Forsyningskjede og lagerstyring",
      "IT-støtte og vedlikehold",
    ],
  },
  {
    id: 3,
    version: "long",
    level: 0,
    question:
      "Hvor ofte evaluerer bedriften din prosesser for automatiseringsmuligheter?",
    options: [
      "Tilpasset",
      "Kvartalsvis",
      "Årlig",
      "Kun når utfordringer oppstår",
      "Vi evaluerer dette ikke aktivt",
    ],
  },
  {
    id: 4,
    version: "long",
    level: 1,
    title: "Dataintegrasjon og analyser",
    question:
      "Hvor integrerte er datasystemene dine (f.eks. CRM, ERP, Regnskap) på tvers av avdelinger?",
    options: [
      "Tilpasset",
      "Fullt integrert, med sanntidsdeling av data",
      "Mest integrert, med regelmessig datasynkronisering",
      "Delvis integrert, med sporadiske manuelle dataoppdateringer",
      "Ikke integrert; data er isolert",
    ],
  },
  {
    id: 5,
    version: "long",
    level: 1,
    question:
      "I hvilken grad bruker selskapet ditt dataanalyser for beslutningstaking?",
    options: [
      "Tilpasset",
      "Avanserte analyser (prediktive, preskriptive)",
      "Enkle analyser (dashbord, historisk rapportering)",
      "Begrensede analyser; data gjennomgås sporadisk",
      "Dataanalyse er ikke en del av vår beslutningstaking",
    ],
  },
  {
    id: 6,
    version: "long",
    level: 2,
    title: "IT-infrastruktur og sikkerhet",
    question:
      "Hvor oppdatert er IT-infrastrukturen din (f.eks. servere, skytjenester)?",
    options: [
      "Tilpasset",
      "Fullt moderne og skalerbar, ved bruk av den nyeste teknologien",
      "Nylig oppdatert, men kan kreve forbedringer",
      "Krever en betydelig oppgradering",
      "Utdatert og sjelden oppgradert",
    ],
  },
  {
    id: 7,
    version: "long",
    level: 2,
    question:
      "Hvilket nivå av sikkerhetstiltak er på plass for dine digitale systemer?",
    options: [
      "Tilpasset",
      "Omfattende cybersikkerhetsprogram (brannmurer, trusselovervåking, regelmessige revisjoner)",
      "Grunnleggende sikkerhetstiltak (brannmurer, antivirus)",
      "Minimale sikkerhetstiltak; ikke regelmessig overvåket",
      "Sikkerhet er ikke et stort fokus",
    ],
  },
  {
    id: 8,
    version: "long",
    level: 3,
    title: "Bruk av ny teknologi",
    question:
      "Hvor ofte tar selskapet ditt i bruk ny teknologi for å forbedre effektiviteten?",
    options: [
      "Tilpasset",
      "Kontinuerlig; vi søker aktivt etter ny teknologi",
      "Av og til, når vi identifiserer et spesifikt behov",
      "Sjelden; vi bruker etablerte metoder og verktøy",
      "Ikke i det hele tatt; vi motsetter oss store endringer",
    ],
  },
  {
    id: 9,
    version: "long",
    level: 3,
    question:
      "Hvilke av disse teknologiene er for øyeblikket en del av virksomheten din?",
    options: [
      "Tilpasset",
      "Kunstig intelligens eller maskinlæring",
      "IoT (Internet of Things)-enheter eller systemer",
      "Skybaserte løsninger",
      "Ingen av de ovennevnte",
    ],
  },
  {
    id: 10,
    version: "long",
    level: 4,
    title: "Innovasjonskultur og ledelse",
    question:
      "Hvordan vil du beskrive ledelsens tilnærming til digital transformasjon?",
    options: [
      "Tilpasset",
      "Proaktiv og sterkt investert i digital transformasjon",
      "Åpen for digital endring, med sporadiske investeringer",
      "Forsiktig optimistisk, men treg til å investere",
      "Motstandsdyktig mot digital transformasjon",
    ],
  },
  {
    id: 11,
    version: "long",
    level: 4,
    question:
      "Hvor ofte får teamet ditt opplæring i digitale verktøy og praksis?",
    options: [
      "Tilpasset",
      "Regelmessig, med oppdaterte opplæringsøkter",
      "Av og til, men ikke konsekvent",
      "Sjelden; vi prioriterer ikke digital opplæring",
      "Aldri; ingen formell digital opplæring tilbys",
    ],
  },
  {
    id: 12,
    version: "long",
    level: 5,
    title: "Kundeopplevelse og engasjement",
    question: "Hvor integrert er digital teknologi i kundeinteraksjonene dine?",
    options: [
      "Tilpasset",
      "Fullt digitalisert (f.eks. automatisert kundeservice, CRM-integrasjon)",
      "Mest digital, med noe manuell støtte",
      "Delvis digital, med stor avhengighet av manuell støtte",
      "Ikke digitalisert; alle kundeinteraksjoner er manuelle",
    ],
  },
  {
    id: 13,
    version: "long",
    level: 5,
    question:
      "Samler selskapet ditt aktivt inn kundetilbakemeldinger for å styre digitale forbedringer?",
    options: [
      "Tilpasset",
      "Ja, regelmessig gjennom undersøkelser, analyser og direkte tilbakemeldinger",
      "Av og til, med begrensede tilbakemeldingskanaler",
      "Sjelden; vi fokuserer på interne innsikter",
      "Nei, vi samler ikke inn kundetilbakemeldinger",
    ],
  },
  {
    id: 14,
    version: "long",
    level: 6,
    title: "Overordnet digital strategi",
    question: "Har selskapet ditt en dokumentert digital transformasjonsplan?",
    options: [
      "Tilpasset",
      "Ja, med klare mål, tidslinjer og målinger",
      "Ja, men den er bare delvis implementert",
      "Nei, men vi utvikler en",
      "Nei, vi har ingen digital transformasjonsstrategi",
    ],
  },
  {
    id: 15,
    version: "long",
    level: 6,
    question: "Hvordan måler selskapet ditt suksess i digitaliseringsarbeidet?",
    options: [
      "Tilpasset",
      "Gjennom definerte KPI-er og hyppige ytelsesgjennomganger",
      "Gjennom generelle forretningsresultater, men ikke spesifikke KPI-er",
      "Ingen formell måling; det er basert på opplevd suksess",
      "Vi måler ikke suksess i digitalisering",
    ],
  },
  {
    id: 16,
    version: "long",
    level: 7,
    title: "Resultater",
    question: "E-postadresse:",
    options: [],
    type: "input",
  },
  {
    id: 17,
    version: "short",
    level: 0,
    title: "Automatisering av prosesser",
    question:
      "Hvor automatiserte er selskapets primære forretningsprosesser (f.eks. produksjon, kundeservice, HR)?",
    options: [
      "Tilpasset",
      "Fullt automatisert med minimal manuell intervensjon",
      "Mest automatisert, med noen manuelle kontroller",
      "Delvis automatisert, krever betydelig manuelt arbeid",
      "Ikke automatisert; prosessene er for det meste manuelle",
    ],
  },
  {
    id: 18,
    version: "short",
    level: 1,
    title: "Dataintegrasjon og analyser",
    question:
      "Hvor integrerte er selskapets datasystemer (f.eks. CRM, ERP, Finans), og i hvilken grad brukes dataanalyse i beslutningstaking?",
    options: [
      "Tilpasset",
      "Fullt integrert, med avanserte analyser som styrer beslutninger",
      "Mest integrert, ved bruk av grunnleggende analyser i beslutningstaking",
      "Delvis integrert, med begrenset bruk av analyser",
      "Data er isolert, og analyser brukes sjelden i beslutningstaking",
    ],
  },
  {
    id: 19,
    version: "short",
    level: 2,
    title: "IT-infrastruktur og sikkerhet",
    question:
      "Hvor moderne er IT-infrastrukturen din, og hvilke nivåer av cybersikkerhetstiltak er på plass?",
    options: [
      "Tilpasset",
      "Fullt oppdatert, med omfattende cybersikkerhetstiltak",
      "Mest moderne, med grunnleggende cybersikkerhetstiltak",
      "Infrastrukturen er utdatert, men har minimale cybersikkerhetstiltak",
      "Infrastrukturen er utdatert, med begrenset eller ingen cybersikkerhet",
    ],
  },
  {
    id: 20,
    version: "short",
    level: 3,
    title: "Ledelsens tilnærming til digital transformasjon",
    question:
      "Hvordan vil du beskrive ledelsens tilnærming til digital transformasjon og innovasjon?",
    options: [
      "Tilpasset",
      "Proaktiv, sterkt investert i digitale initiativer",
      "Åpen for digitale endringer, med sporadiske investeringer",
      "Forsiktig optimistisk, men treg til å investere",
      "Motstandsdyktig mot digital transformasjon",
    ],
  },
  {
    id: 21,
    version: "short",
    level: 4,
    title: "Kundeopplevelse og digitalt engasjement",
    question:
      "I hvilken grad er digital teknologi integrert i kundeinteraksjonene dine (f.eks. automatisert støtte, CRM-integrasjon)?",
    options: [
      "Tilpasset",
      "Fullt digitalisert, med kundeinteraksjoner hovedsakelig automatisert",
      "Mest digital, med noe manuell støtte",
      "Delvis digital, med betydelig avhengighet av manuelle prosesser",
      "Ikke digitalisert; interaksjoner er primært manuelle",
    ],
  },
  {
    id: 22,
    version: "short",
    level: 5,
    title: "Resultater",
    question: "E-postadresse:",
    options: [],
    type: "input",
  },
];
